import { useMemo } from "react";
import { Field } from "react-final-form";

import DollarInput from "../../inputs/DollarInput";
import RffInputWrapper from "../shared/RffInputWrapper";

const RffDollarField = ({
  name,
  label,
  required,
  helperText,
  placeholder,
  fullWidth,
  suppressGrid,
  onBlur,
  size,
  disabled,
}) => {
  const validateDollarAmount = useMemo(() => {
    return (value) => {
      if (required && (value === undefined || value === null || value === "")) {
        return "This field is required";
      }

      return undefined;
    };
  }, [required]);

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
    >
      <Field
        name={name}
        validate={validateDollarAmount}
        parse={(value) => {
          if (value === "") return undefined;
          if (value === null) return null;
          return value;
        }}
        render={({ input, meta }) => (
          <DollarInput
            {...input}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            fullWidth={fullWidth}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error ? meta.error : helperText}
          />
        )}
      />
    </RffInputWrapper>
  );
};

export default RffDollarField;
